import {  MDateTime, MCity } from '@sailor/i18n-web'
import { getQueryValues } from '.'
import { getLanguage } from './i18n'


// 时间戳解析为日期/时间字符串
const getTimestamp2Str = ({
  timestamp, // 毫秒/秒
  dateStyle = 1, // 日期格式 默认1
  timeStyle = 1, // 时间格式 默认1
  timestampType = 2, // 类型 1毫秒 2秒
  pattern, // 自定义 pattern https://sky.sankuai.com/docs/sailor/sailor_i18n_doc/java-sdk/datetime/pattern.html
  cityId = getCurCityId(), // 默认当前全局城市id
}: {
  timestamp: number
  dateStyle?: number
  timeStyle?: number
  timestampType?: number
  pattern?: string
  cityId?: number
}) => {
  if (!timestamp) return ''
  return pattern
    ? MDateTime.formatByCityIdWithPattern(cityId, timestampType === 1 ? timestamp : timestamp * 1000, pattern, getLanguage())
    : MDateTime.formatByCityId(cityId, timestampType === 1 ? timestamp : timestamp * 1000, dateStyle, timeStyle, getLanguage())
}


// 获取用户所选国家的首都ID
const getCurCityId = () => MCity.getCapitalCityIdByRegion(getRegion())

export const getI18nTime = (time: number, formater?: string) => getTimestamp2Str({ timestamp: Number(time), timestampType: 1, pattern: formater || 'yyyy-MM-dd' })


export function getLocalInfo () {
  try {
    return JSON.parse(sessionStorage.getItem('FE_LOCAL_INFO') || '{}')
  } catch (error) {
    return {}
  }
}

export function updateLocalInfo (info: {[k:string]: any, region: string, timeZone: string, locale: string}) {
  sessionStorage.setItem('FE_LOCAL_INFO', JSON.stringify(info))
}
export function getRegion () {
  let region = getQueryValues('region') || getLocalInfo().region || ''
  return String(region)
}

export function isEn () {
  return getLanguage() === 'en'
}
export function isZh () {
  return getLanguage()?.includes('zh')
}

// export function isZh () {
//   return getLanguage() === 'zh' || getLanguage() === 'zh-HK'
// }
